import React, { useEffect } from "react";
import SideBar from "../sidebar/SideBar";
import { useMyContext } from "../../context/MyContext";
import ChangePasswordModal from "../ChangePasswordModal";
import PopupWrapper from "../PopupWrapper";

const obj = {
    active: true,
    content: "Dashboard",
};

const DashboardLayout = ({ children }) => {
    const { passwordChangeModal, setPasswordChangeModal } = useMyContext();
    // console.log("passwordChangeModal", passwordChangeModal);
  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    // Prevent browser/window scrolling in dashboard pages.
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);

  return (
    <>
      <div className="flex w-full h-screen bg-cus-gray overflow-hidden">
        <div className="h-screen w-[14%] sm:block hidden border-r ">
          <SideBar obj={obj} />
        </div>
        <div className="w-full md:w-[86%] bg-cus-gray h-screen overflow-y-auto">
          {children}
        </div>
      </div>
      {passwordChangeModal && (
        <ChangePasswordModal
          onCancel={() => setPasswordChangeModal(false)}
          visible={passwordChangeModal}
        />
      )}
      <PopupWrapper />
    </>
  );
};

export default DashboardLayout;
